import { render, staticRenderFns } from "./SidebarFieldset.vue?vue&type=template&id=c6b03532&"
import script from "./SidebarFieldset.vue?vue&type=script&lang=js&"
export * from "./SidebarFieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports